const HOST = '/api';
const version = "6.7";
const source = "Qmis";
const queryString=`source=${source}&version=${version}`;

const API = {
    LOGIN: `${HOST}/user/common-api/login?${queryString}`,
    EDIT_QUESTION:`${HOST}/entry_question/qbox/mix-add-edit?${queryString}`,
    GET_JSON_STYLE:`${HOST}/entry_question/qbox/json-style?${queryString}`,
    GET_TASK_LIST:`${HOST}/entry_task/manage/page-list?${queryString}`,
    GET_TASK_STATIC:`${HOST}/entry_task/manage/statistics?${queryString}`,
    GET_TASK_DETAIL:`${HOST}/entry_task/manage/detail?${queryString}`,
    DEL_TASK:`${HOST}/entry_task/manage/del?${queryString}`,
    GET_CLERK_LIST:`${HOST}/entry_task/user-new/entry-user-list?${queryString}`,
    GET_GROUP_LIST:`${HOST}/entry_task/user-new/entry-group-list?${queryString}`,
    GET_VERIFIER_LIST:`${HOST}/entry_task/user-new/check-user-list?${queryString}`,
    GET_TASK_INFO:`${HOST}/entry_task/manage/info?${queryString}`,
    ADD_TASK:`${HOST}/entry_task/manage/add?${queryString}`,
    DELETE_TASK:`${HOST}/entry_task/manage/delete?${queryString}`,
    EDIT_TASK:`${HOST}/entry_task/manage/edit?${queryString}`,
    GET_USER_INFO:`${HOST}/common/user/info?${queryString}`,
    GET_SUBJECT:`${HOST}/entry_task/global/info?${queryString}`,
    GET_EDITION:`${HOST}/entry_task/global/edition?${queryString}`,
    GET_BOOK:`${HOST}/entry_task/global/book?${queryString}`,
    GET_ASSIST:`${HOST}/entry_task/global/assist?${queryString}`,
    GET_SECTION:`${HOST}/entry_task/global/course-section?${queryString}`,
    GET_PAPER:`${HOST}/entry_task/global/paper?${queryString}`,
    DEPLOY_TASK:`${HOST}/entry_task/manage/online-to-base?${queryString}`,
    CHECK_PASS:`${HOST}/entry_task/process/check-pass?${queryString}`,
    CHECK_REWORK:`${HOST}/entry_task/process/check-rework?${queryString}`,
    RESUBMIT:`${HOST}/entry_task/process/entry-rework-submit?${queryString}`,
    ON_SUBMIT:`${HOST}/entry_task/process/entry-submit?${queryString}`,
    ON_REVOCATION:`${HOST}/entry_task/process/undo-assign-user?${queryString}`,
    GET_ERROR_DUTY:`${HOST}/entry_task/question-new/detail-with-user?${queryString}`,//错题追责
    GET_REWORK_LIST:`${HOST}/entry_task/question-new/rework-list?${queryString}`,//返工列表
    GET_ENTRYING_LIST:`${HOST}/entry_task/question-new/entrying-list?${queryString}`,//未审查列表
    GET_ALL_LIST:`${HOST}/entry_task/question-new/all-list?${queryString}`,//全部列表
    GET_PASS_LIST:`${HOST}/entry_task/question-new/pass-list?${queryString}`,//审核通过列表

    DEL_QUESTION:`${HOST}/entry_task/question-new/del?${queryString}`,//题目删除
    CHECK_PASS_QUESTION:`${HOST}/entry_task/question-new/check-pass?${queryString}`,//题目审核通过
    CHECK_REWORK_QUESTION:`${HOST}/entry_task/question-new/check-rework?${queryString}`,//题目返工

    ADD_QUESTION:`${HOST}/entry_question/qbox/mix-add-edit?${queryString}`,//录题
    ADD_QUESTION_CHECK:`${HOST}/entry_question/qbox/check-add-edit?${queryString}`,//录题检验

    GET_QUESTION:`${HOST}/entry_question/qbox/detail?${queryString}`,//改题获得数据

    ASSIGN_CLERK:`${HOST}/entry_task/process/assign-user?${queryString}`,//分配录入员
    ASSIGN_GROUP:`${HOST}/entry_task/process/assign-group?${queryString}`,//分配组
    ASSIGN_VERIFIER:`${HOST}/entry_task/process/assign-check-user?${queryString}`,//分配校验
    ASSIGN_VERIFIER_AGAIN:`${HOST}/entry_task/process/assign-check-user-again?${queryString}`,//分配校验

    /*根据id数组获取题目*/
    QUESTION_BY_ID: `${HOST}/book_questionall/tree/question-by-id?${queryString}`,

    UPLOAD_TOKEN:`${HOST}/common/qiniu/upload-token?${queryString}`,//qiniuTOKEN
    EXIT_LOGIN:`${HOST}/user/common-api/login-out?${queryString}`,//退出登陆

    /*获取allowtype列表*/
    GET_TYPE_LIST: `${HOST}/book_questionall/tree/type-no-subject?${queryString}`,
    /*获取无需学科学段的章节列表*/
    GET_NO_SUBJECT_ASSIST_LIST: `${HOST}/book_questionall/tree/select-assist-list?${queryString}`,
    /*获取树节点*/
    GET_TREE_LIST: `${HOST}/book_questionall/tree/select-tree-list?${queryString}`,
    /*章节下的筛选条件列表接口*/
    ASSIT_QUESTION_FILTER: `${HOST}/book_questionall/tree/question-filter?${queryString}`,
    /*查看题目列表 教辅章节 知识点 题目列表三合一*/
    GET_QUESTION_LIST: `${HOST}/book_questionall/tree/question-list?${queryString}`,
    /*修改学科学段*/
    UPDATE_SUBJECT: `${HOST}/common/user/update-subject?${queryString}`,


    /*质量控制-修改题目的验证*/
    MODIFY_QUALITY_QUESTION_CHECK: `${HOST}/common/question/check-modify?${queryString}`,
    /*质量控制-修改题目*/
    MODIFY_QUALITY_QUESTION: `${HOST}/common/question/modify?${queryString}`,
    /*质量控制-查看题目*/
    QUALITY_CHECK_QUESTION: `${HOST}/common/question/detail?${queryString}`,
    /*删除题目关联关系*/
    DEL_QUESTION_RELATE: `${HOST}/book_questionall/tree/delete-question-relate?${queryString}`,
    /*题目删除*/
    QIUESTION_LOOK_DEL_QUESTION: `${HOST}/book_questionall/tree/del-question?${queryString}`,
    /*题目上线线*/
    QIUESTION_LOOK_ONLINE_QUESTION: `${HOST}/book_questionall/tree/online-question?${queryString}`,
    /*题目下线*/
    QIUESTION_LOOK_OFFLINE_QUESTION: `${HOST}/book_questionall/tree/offline-question?${queryString}`,
    /*设置题目类型*/
    SET_QUESTION_WELLCHOSEN: `${HOST}/book_questionall/tree/set-wellchosen?${queryString}`,
    /*设置题目正确按钮*/
    SET_QUESTION_USER_CHECK: `${HOST}/book_questionall/tree/set-usercheck?${queryString}`,
    /*设置评测题*/
    SET_QUESTION_IS_EVALUATION: `${HOST}/book_questionall/tree/set-evaluation?${queryString}`,
    /*导出已选题目到指定知识点*/
    COPY_SELECT_QUESTION: `${HOST}/book_questionall/tree/copy-select-question?${queryString}`,
    /*合成语音*/
    GENERTOR_STEM_AUDIO: `${HOST}/book_questionall/tree/synthetic-voice?${queryString}`,

    /*任务-获取可分配人员列表*/
    GET_USER_LIST: `${HOST}/qselect_user/user-common/user-list?${queryString}`,


//4.2图片解析相关api------------------------------------------------------
  //任务流程相关
    /*图片解析录入提交*/
    PIC_ENTRY_SUBMIT: `${HOST}/qexplain/task-op/pic-entry-submit?${queryString}`,
    /*图片解析录入返工提交*/
    PIC_ENTRY_RESUBMIT: `${HOST}/qexplain/task-op/pic-entry-resubmit?${queryString}`,
    /*图片解析审核通过*/
    PIC_CHECK_PASS: `${HOST}/qexplain/task-op/pic-check-pass?${queryString}`,
    /*图片解析审核返工*/
    PIC_CHECK_REWORK: `${HOST}/qexplain/task-op/pic-check-rework?${queryString}`,

    /*文字解析录入提交*/
    TEXT_ENTRY_SUBMIT: `${HOST}/qexplain/task-op/text-entry-submit?${queryString}`,
    /*文字解析录入返回提交*/
    TEXT_ENTRY_RESUBMIT: `${HOST}/qexplain/task-op/text-entry-resubmit?${queryString}`,
    /*文字解析审核通过*/
    TEXT_CHECK_PASS: `${HOST}/qexplain/task-op/text-check-pass?${queryString}`,
    /*文字解析审核返工*/
    TEXT_CHECK_REWORK: `${HOST}/qexplain/task-op/text-check-rework?${queryString}`,

 //任务管理相关

    /*任务-获取解析任务列表*/
    GET_EXPLAIN_TASK_LIST: `${HOST}/qexplain/task-manage/page-list?${queryString}`,
    /*任务-添加任务*/
    EXPLAIN_TASK_ADD: `${HOST}/qexplain/task-manage/add?${queryString}`,
    /*任务-删除*/
    EXPLAIN_TASK_DEL: `${HOST}/qexplain/task-manage/del?${queryString}`,
    /*任务-入库*/
    EXPLAIN_TASK_ONLINE: `${HOST}/qexplain/task-manage/online-to-base?${queryString}`,
    /*任务-详情*/
    EXPLAIN_TASK_DETAIL: `${HOST}/qexplain/task-manage/detail?${queryString}`,
    /*任务-入库*/
    EXPLAIN_TASK_INFO: `${HOST}/qexplain/task-manage/info?${queryString}`,

    /*任务-导出*/
    EXPLAIN_TASK_EXPORT: `${HOST}/qexplain/task-manage/statistics?${queryString}`,

 //任务题目相关
    /*图片解析录入保存*/
    QUESTION_PIC_ENTRY_SUBMIT: `${HOST}/qexplain/task-question/pic-entry-submit?${queryString}`,
    /*图片解析返工录入保存*/
    QUESTION_PIC_ENTRY_RESUBMIT: `${HOST}/qexplain/task-question/pic-entry-resubmit?${queryString}`,

    /*图片解析审核通过*/
    QUESTION_PIC_CHECK_PASS: `${HOST}/qexplain/task-question/pic-check-pass?${queryString}`,
    /*图片解析审核返工*/
    QUESTION_PIC_CHECK_REWORK: `${HOST}/qexplain/task-question/pic-check-rework?${queryString}`,
    /*图片解析审核修改后通过*/
    QUESTION_PIC_CHECK_MOD_SUBMIT: `${HOST}/qexplain/task-question/pic-check-mod-submit?${queryString}`,

    /*文字解析录入保存*/
    QUESTION_TEXT_ENTRY_SUBMIT: `${HOST}/qexplain/task-question/text-entry-submit?${queryString}`,
    /*文字解析返工录入保存*/
    QUESTION_TEXT_ENTRY_RESUBMIT: `${HOST}/qexplain/task-question/text-entry-resubmit?${queryString}`,

    /*文字解析超级管理员修改保存*/
    QUESTION_TEXT_ENTRY_ADMINEDIT: `${HOST}/qexplain/task-question/text-admin-edit`,
    /*文字解析审核通过*/
    QUESTION_TEXT_CHECK_PASS: `${HOST}/qexplain/task-question/text-check-pass?${queryString}`,
    /*文字解析审核返工*/
    QUESTION_TEXT_CHECK_REWORK: `${HOST}/qexplain/task-question/text-check-rework?${queryString}`,
    /*文字解析审核修改后通过*/
    QUESTION_TEXT_CHECK_MOD_SUBMIT: `${HOST}/qexplain/task-question/text-check-mod-submit?${queryString}`,

    /*解析检测追责*/
    QUESTION_ERROR_CHECK: `${HOST}/qexplain/question/error-check?${queryString}`,

    /*任务详情题目列表*/
    QUESTION_DETAIL_PAGE_LIST: `${HOST}/qexplain/task-question/page-list?${queryString}`,



//用户分配相关
    /*获得图片解析组列表*/
    GET_PIC_GROUP_LIST: `${HOST}/qexplain/task-user/pic-group-list?${queryString}`,
    /*获得文字解析组列表*/
    GET_TEXT_GROUP_LIST: `${HOST}/qexplain/task-user/text-group-list?${queryString}`,

    /*获得图片解析员列表*/
    GET_PIC_USER_LIST: `${HOST}/qexplain/task-user/pic-user-list?${queryString}`,
    /*获得文字解析员列表*/
    GET_TEXT_USER_LIST: `${HOST}/qexplain/task-user/text-user-list?${queryString}`,

    /*获得图片审核员列表*/
    GET_PIC_CHECKUSER_LIST: `${HOST}/qexplain/task-user/pic-check-user-list?${queryString}`,
    /*获得文字审核员列表*/
    GET_TEXT_CHECKUSER_LIST: `${HOST}/qexplain/task-user/text-check-user-list?${queryString}`,

    /*分配图片解析组*/
    ASSIGN_PIC_GROUP: `${HOST}/qexplain/task-user/pic-group?${queryString}`,
    /*分配图片解析员*/
    ASSIGN_PIC_USER: `${HOST}/qexplain/task-user/pic-user?${queryString}`,
    /*修改图片解析员*/
    MOD_ASSIGN_PIC_USER: `${HOST}/qexplain/task-user/pic-user-mod?${queryString}`,
    /*分配图片解析审核员*/
    ASSIGN_PIC_CHECK_USER: `${HOST}/qexplain/task-user/pic-check-user?${queryString}`,

    /*分配文字解析组*/
    ASSIGN_TEXT_GROUP: `${HOST}/qexplain/task-user/text-group?${queryString}`,
    /*分配文字解析员*/
    ASSIGN_TEXT_USER: `${HOST}/qexplain/task-user/text-user?${queryString}`,
    /*修改文字解析员*/
    MOD_ASSIGN_TEXT_USER: `${HOST}/qexplain/task-user/text-user-mod?${queryString}`,
    /*分配文字解析审核员*/
    ASSIGN_TEXT_CHECK_USER: `${HOST}/qexplain/task-user/text-check-user?${queryString}`,

//组管理相关
    GET_ADMIN_EXPLAIN_GROUP_LIST: `${HOST}/admin/qexplain-group/list?${queryString}`,
    ADMIN_EXPLAIN_GROUP_DEL: `${HOST}/admin/qexplain-group/del?${queryString}`,
    ADMIN_EXPLAIN_GROUP_ADD: `${HOST}/admin/qexplain-group/add?${queryString}`,
    ADMIN_EXPLAIN_GROUP_EDIT: `${HOST}/admin/qexplain-group/edit?${queryString}`,
    ADMIN_EXPLAIN_GROUP_UPDATE_ADMIN: `${HOST}/admin/qexplain-group/update-admin?${queryString}`,
    ADMIN_EXPLAIN_GROUP_ADD_USER: `${HOST}/admin/qexplain-group/add-user?${queryString}`,
    ADMIN_EXPLAIN_USER_DEL: `${HOST}/admin/qexplain-group/del-user?${queryString}`,


//人员管理列表
    ADMIN_EXPLAIN_USER_LIST: `${HOST}/admin/auth-user/list?${queryString}`,//人员列表
    ADMIN_EXPLAIN_USER_EDIT: `${HOST}/admin/auth-user/edit?${queryString}`,//编辑人员
    ADMIN_EXPLAIN_USER_ROLE_LIST: `${HOST}/admin/auth-user/role-list?${queryString}`,




//   4.3.0增加接口 -------------------------------------------------------------------------
    QERRCHECK_DAILY_LIST: `${HOST}/qerrcheck/daily/list?${queryString}`,//日常报错-报错日志列表
    QERRCHECK_DAILY_LIST_EXPORT: `${HOST}/qerrcheck/daily/export?${queryString}`,//日常报错-报错日志列表
    QERRCHECK_DAILY_LOG_LIST: `${HOST}/qerrcheck/daily/log-list?${queryString}`,//日常报错-报错日志列表
    QERRCHECK_DAILY_FILTER: `${HOST}/qerrcheck/daily/filter?${queryString}`,//搜索时的筛选项
    QERRCHECK_DAILY_SUBMIT: `${HOST}/qerrcheck/daily/check-submit?${queryString}`,//搜索时的筛选项

    //外包任务
    QERRCHECK_HOMEWORK_TASK_LIST: `${HOST}/qerrcheck/homework-task/page-list?${queryString}`,//搜索时的筛选项


    //下载创建外包任务模版
    QERRCHECK_HOMEWORK_TASK_LIST_ADD_DOWNLOAD: `${HOST}/statics/publish_homework.xlsx?${queryString}`,
    //创建外包任务
    QERRCHECK_HOMEWORK_TASK_LIST_ADD: `${HOST}/qerrcheck/homework-task/add?${queryString}`,
    //完成
    QERRCHECK_HOMEWORK_TASK_LIST_END: `${HOST}/qerrcheck/homework-task/homework-end?${queryString}`,
    //外包任务题目列表
    HOMEWORK_TASK_PAGE_LIST: `${HOST}/qerrcheck/homework-task-question/page-list?${queryString}`,

    //外包任务题目处理选项
    HOMEWORK_TASK_ERROR_TYPE: `${HOST}/qerrcheck/homework-task-question/error-type?${queryString}`,

    // 外包报错-任务题目作业记录
    HOMEWORK_RECORD: `${HOST}/qerrcheck/homework-task-question/homework-record?${queryString}`,
    // 外包报错-任务题目检错审核提交
    HOMEWORK_CHECK_SUBMIT: `${HOST}/qerrcheck/homework-task-question/check-submit?${queryString}`,

    // 外包报错-任务统计
    HOMEWORK_EXPORT_STATISTICS: `${HOST}/qerrcheck/homework-task/statistics?${queryString}`,

    // 检错黑名单列表
    QUESTION_ERROR_BLACK_LIST: `${HOST}/qerrcheck/black/list?${queryString}`,


    QERRCHECK_BLACK_LIST: `${HOST}/qerrcheck/black/list?${queryString}`,
    QERRCHECK_BLACK_REMOVE: `${HOST}/qerrcheck/black/remove?${queryString}`,
    QERRCHECK_BLACK_ADD: `${HOST}/qerrcheck/black/add?${queryString}`,
    QERRCHECK_BLACK_TEACHER_INFO: `${HOST}/qerrcheck/black/teacher-info?${queryString}`,

	//v4.4.0
    //教辅相关
    FRAMEEWORK_FILTER: `${HOST}/framework/global/filter?${queryString}`,//全局筛选项
    FRAMEEWORK_ASSIST_TEST: `${HOST}/framework/assist/test?${queryString}`,
    FRAMEEWORK_ASSIST_ONLINE: `${HOST}/framework/assist/online?${queryString}`,
    FRAMEEWORK_ASSIST_OFFLINE: `${HOST}/framework/assist/offline?${queryString}`,
    FRAMEEWORK_ASSIST_LIST: `${HOST}/framework/assist/list?${queryString}`,
    FRAMEEWORK_ASSIST_ADD: `${HOST}/framework/assist/add?${queryString}`,
    FRAMEEWORK_ASSIST_MOVE: `${HOST}/framework/assist/move?${queryString}`,
    FRAMEEWORK_ASSIST_EDIT: `${HOST}/framework/assist/edit?${queryString}`,
    FRAMEEWORK_ASSIST_DEL: `${HOST}/framework/assist/del?${queryString}`,
    FRAMEEWORK_ASSIST_DETAIL: `${HOST}/framework/assist/detail?${queryString}`,

    FRAMEEWORK_EDITION_ONLINE: `${HOST}/framework/edition/online?${queryString}`,
    FRAMEEWORK_EDITION_OFFLINE: `${HOST}/framework/edition/offline?${queryString}`,
    FRAMEEWORK_EDITION_LIST: `${HOST}/framework/edition/list?${queryString}`,
    FRAMEEWORK_EDITION_ADD: `${HOST}/framework/edition/add?${queryString}`,
    FRAMEEWORK_EDITION_DEL: `${HOST}/framework/edition/del?${queryString}`,
    FRAMEEWORK_EDITION_EDIT: `${HOST}/framework/edition/edit?${queryString}`,
    FRAMEEWORK_EDITION_DETAIL: `${HOST}/framework/edition/detail?${queryString}`,

    FRAMEEWORK_KNOWLEDGE_ONLINE: `${HOST}/framework/knowledge/online?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_OFFLINE: `${HOST}/framework/knowledge/offline?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_DOWNLOAD: `${HOST}/framework/knowledge/download?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_EDIT: `${HOST}/framework/knowledge/edit?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_TREE: `${HOST}/framework/knowledge/know-issue-tree?${queryString}`,//知识点列表
    FRAMEEWORK_KNOWLEDGE_DEL: `${HOST}/framework/knowledge/del?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_DOWNLOAD_FORMAT: `${HOST}/framework/knowledge/download-import-format?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_IMPORT: `${HOST}/framework/knowledge/import?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_ADD: `${HOST}/framework/knowledge/add?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_MOVE: `${HOST}/framework/knowledge/move?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_DETAIL: `${HOST}/framework/knowledge/detail?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_KNOW_TREE: `${HOST}/framework/knowledge/know-tree?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_ISSUE_TREE: `${HOST}/framework/knowledge/issue-tree?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_KNOW_IMPORT_FORMAT: `${HOST}/framework/section-know/download-import-format?${queryString}`,
    FRAMEEWORK_KNOWLEDGE_KNOW_IMPORT: `${HOST}/framework/section-know/import?${queryString}`,


    FRAMEEWORK_SECTION_ONLINE: `${HOST}/framework/section/online?${queryString}`,
    FRAMEEWORK_SECTION_OFFLINE: `${HOST}/framework/section/offline?${queryString}`,
    FRAMEEWORK_SECTION_EDIT: `${HOST}/framework/section/edit?${queryString}`,
    FRAMEEWORK_SECTION_LIST: `${HOST}/framework/section/list?${queryString}`,
    FRAMEEWORK_SECTION_DOWNLOAD_LIST: `${HOST}/framework/section/download-list?${queryString}`,
    FRAMEEWORK_SECTION_ADD: `${HOST}/framework/section/add?${queryString}`,
    FRAMEEWORK_SECTION_DEL: `${HOST}/framework/section/del?${queryString}`,
    FRAMEEWORK_SECTION_IMPORT: `${HOST}/framework/section/import?${queryString}`,
    FRAMEEWORK_SECTION_DOWNLOAD_FORMAT: `${HOST}/framework/section/download-import-format?${queryString}`,

    FRAMEEWORK_SECTION_KNOW_DEL: `${HOST}/framework/section-know/del?${queryString}`,
    FRAMEEWORK_SECTION_KNOW_DOWNLOAD: `${HOST}/framework/section-know/download-count?${queryString}`,//!!!!!!!!!!!!!!!!!!!!!!
    FRAMEEWORK_SECTION_KNOW_IMPORT: `${HOST}/framework/section-know/import?${queryString}`,
    FRAMEEWORK_SECTION_KNOW_ADD: `${HOST}/framework/section-know/add?${queryString}`,

    FRAMEEWORK_SECTION_MOVE: `${HOST}/framework/section/move?${queryString}`,
    FRAMEEWORK_SECTION_DETAIL: `${HOST}/framework/section/detail?${queryString}`,

    FRAMEEWORK_BOOK_ONLINE: `${HOST}/framework/book/online?${queryString}`,
    FRAMEEWORK_BOOK_OFFLINE: `${HOST}/framework/book/offline?${queryString}`,
    FRAMEEWORK_BOOK_EDIT: `${HOST}/framework/book/edit?${queryString}`,
    FRAMEEWORK_BOOK_LIST: `${HOST}/framework/book/list?${queryString}`,
    FRAMEEWORK_BOOK_ADD: `${HOST}/framework/book/add?${queryString}`,
    FRAMEEWORK_BOOK_DEL: `${HOST}/framework/book/del?${queryString}`,
    FRAMEEWORK_BOOK_DETAIL: `${HOST}/framework/book/detail?${queryString}`,
    FRAMEEWORK_BOOK_MOVE: `${HOST}/framework/book/move?${queryString}`,

//v4.5.0

    QSELECTTNEW_TASK_FILTER: `${HOST}/qselectnew/task/filter?${queryString}`,//打标签-任务新建筛选项
    QSELECTTNEW_TASK_TEST: `${HOST}/qselectnew/task/test?${queryString}`,//打标签-任务上测试
    QSELECTTNEW_TASK_ONLINE: `${HOST}/qselectnew/task/online?${queryString}`,//打标签-任务入库
    QSELECTTNEW_TASK_END: `${HOST}/qselectnew/task/end?${queryString}`,//打标签-任务关闭
    QSELECTTNEW_TASK_ASSIGN_CHECK_USER: `${HOST}/qselectnew/task/assign-check-user?${queryString}`,//打标签-任务分配审核员
    QSELECTTNEW_TASK_ASSIGN_SELECT_USER: `${HOST}/qselectnew/task/assign-select-user?${queryString}`,//打标签-任务分配选精员
    QSELECTTNEW_TASK_PAGE_LIST: `${HOST}/qselectnew/task/page-list?${queryString}`,//打标签-任务列表
    QSELECTTNEW_TASK_ADD: `${HOST}/qselectnew/task/add?${queryString}`,//打标签-任务创建
    QSELECTTNEW_TASK_DEL: `${HOST}/qselectnew/task/del?${queryString}`,//打标签-任务删除
    QSELECTTNEW_TASK_CHECK_LIST: `${HOST}/qselectnew/task-user/check-list?${queryString}`,//打标签-任务-审核用户列表
    QSELECTTNEW_TASK_QUESTION_PAGE_CHECK: `${HOST}/qselectnew/task-question/question-page-check?${queryString}`,//打标签-任务-审核题目分页id列表
    QSELECTTNEW_TASK_QUESTION_TREE: `${HOST}/qselectnew/task-question/tree?${queryString}`,//打标签-任务-目录树
    QSELECTTNEW_TASK_DOWNLOAD: `${HOST}/qselectnew/download/download?${queryString}`,//打标签-任务统计下载
    QSELECTTNEW_TASK_QUESTION_NODE_TREE: `${HOST}/qselectnew/task-question/node-tree?${queryString}`,//打标签-任务-节点树（知识点、考点、能力。。。）
    QSELECTTNEW_TASK_SELECT_LIST: `${HOST}/qselectnew/task-user/select-list?${queryString}`,//打标签-任务-选精用户列表
    QSELECTTNEW_TASK_QUESTION_PAGE_SELECT: `${HOST}/qselectnew/task-question/question-page-select?${queryString}`,//打标签-任务-选精题目分页id列表
    QSELECTTNEW_TASK_ONLINE_SUSUAN: `${HOST}/qselectnew/task/online-susuan?${queryString}`,//打标签-任务速算上线
    QSELECTTNEW_TASK_QUESTION_CHECK_SUBMIT: `${HOST}/qselectnew/task-question/check-submit?${queryString}`,//打标签-任务-题目-审核提交
    QSELECTTNEW_TASK_QUESTION_REWORK: `${HOST}/qselectnew/task-question/rework?${queryString}`,//打标签-任务-题目-审核返工
    QSELECTTNEW_TASK_QUESTION_PASS: `${HOST}/qselectnew/task-question/pass?${queryString}`,//打标签-任务-题目-审核通过
    QSELECTTNEW_TASK_QUESTION_DETAIL: `${HOST}/qselectnew/task-question/detail?${queryString}`,//打标签-任务-题目-查看详情
    QSELECTTNEW_TASK_QUESTION_SELECT_SUBMIT: `${HOST}/qselectnew/task-question/select-submit?${queryString}`,//打标签-任务-题目-选精提交
    QSELECTTNEW_TASK_QUESTION_SUBMIT: `${HOST}/qselectnew/question/submit?${queryString}`,//打标签-非任务-标签提交
    QSELECTTNEW_TASK_QUESTION_BATCH_SUBMIT: `${HOST}/qselectnew/question/batch-submit?${queryString}`,//打标签-非任务-标签提交批量
    QSELECTTNEW_QUESTION_NODE_TREE: `${HOST}/qselectnew/question/node-tree?${queryString}`,//打标签-非任务-节点数（知识点、考点、能力。。。）
    QSELECTTNEW_QUESTION_DETAIL: `${HOST}/qselectnew/question/detail?${queryString}`,//打标签-非任务-题目查看

//v4.5.1
    /*设置题目展示类型*/
    SET_QUESTION_DISPLAY_TYPE: `${HOST}/book_questionall/tree/set-displaytype?${queryString}`,

    //4。6。0？
    AllOW_TYPE: `${HOST}/book_questionall/tree/allow-type?${queryString}`,//获得批量导题的根选项

    //v5.0
    CATEITEM_LIST: `${HOST}/common/question/question-page-content?${queryString}`,//获得批量导题的根选项
    ADD_NEW_WORD_ADD_RELATE: `${HOST}/entry_question/qbox/add-and-relate?${queryString}`,//增加新字词
    LOOKOVER_WORD_BANK: `${HOST}/framework/cateitem/cateitem-list?${queryString}`,//查看字词库
    EXPORT_WORD_BANK: `${HOST}/framework/cateitem/cateitem-statistics?${queryString}`,//查看字词库
    FRAMEEWORK_SECTION_KNOW_DEL_CATEITEM: `${HOST}/framework/cateitem-section/del-relate?${queryString}`,
    FRAMEEWORK_SECTION_ADD_RELATE_WORD_CHECK: `${HOST}/framework/cateitem-section/check-add-relate?${queryString}`,//关联字词检查
    FRAMEEWORK_SECTION_ADD_RELATE_WORD: `${HOST}/framework/cateitem-section/add-relate?${queryString}`,//关联字词
    FRAMEEWORK_SECTION_CATEITEM_ADD: `${HOST}/framework/cateitem/add?${queryString}`,//关联字词

//v5.0.1
    FRAMEEWORK_KNOWLEDGE_ADD_PRE: `${HOST}/framework/knowledge/check-pre?${queryString}`,//前置知识点


    //v6.0.1
    /*任务-导出*/
    QUESTION_MANAGE_EXPORT: `${HOST}/common/question/question-statistics?${queryString}`,

    /*任务-导出-检查*/
    QUESTION_MANAGE_EXPORT_CHECK: `${HOST}/common/question/check-question-statistics?${queryString}`,
    //
    QSELECTTNEW_TASK_CHANGE_SPREAD: `${HOST}/qselectnew/task/change-spread?${queryString}`,//打标签任务是否泛化
    //
    QSELECTTNEW_TASK_TAG_TYPE: `${HOST}/qselectnew/task/tag-type?${queryString}`,//标签类型任务枚举
    QSELECTTNEW_TASK_GET_TAG_TYPE: `${HOST}/qselectnew/task/get-tag-type?${queryString}`,//标签类型任务枚举

    //v6.5   标记
    EVALUATION_TASK_ADD: `${HOST}/evaluation/task/add?${queryString}`,//任务新建
    EVALUATION_TASK_ASSIGN_USER: `${HOST}/evaluation/process/assign-user?${queryString}`,//分配标记人
    EVALUATION_TASK_ASSIGN_USER_CHECK: `${HOST}/evaluation/process/assign-check-user?${queryString}`,//分配审核人
    EVALUATION_TASK_SUBMIT: `${HOST}/evaluation/process/evaluation-submit?${queryString}`,//提交标记任务
    EVALUATION_TASK_REWORK_SUBMIT: `${HOST}/evaluation/process/rework-submit?${queryString}`,//返工中提交任务
    EVALUATION_TASK_REWORK: `${HOST}/evaluation/process/check-rework?${queryString}`,//返工任务

    EVALUATION_TASK_CHECK_PASS: `${HOST}/evaluation/process/check-pass?${queryString}`,//任务审核通过
    EVALUATION_TASK_ONLINE: `${HOST}/evaluation/task/online-to-base?${queryString}`,//任务上线
    EVALUATION_TASK_INFO: `${HOST}/evaluation/task/info?${queryString}`,//任务详情
    EVALUATION_TASK_DEL: `${HOST}/evaluation/task/del?${queryString}`,//任务详情


    EVALUATION_TASK_QUESTION_SUBMIT: `${HOST}/evaluation/task-question/evaluation-submit?${queryString}`,//题目标记提交
    EVALUATION_TASK_QUESTION_PASS: `${HOST}/evaluation/task-question/pass?${queryString}`,//题目通过
    EVALUATION_TASK_QUESTION_REWORK: `${HOST}/evaluation/task-question/rework?${queryString}`,//题目审核返工
    EVALUATION_TASK_QUESTION_MOD_SUBMIT: `${HOST}/evaluation/task-question/modify?${queryString}`,//题目标记提交


    EVALUATION_TASK_LIST: `${HOST}/evaluation/task/page-list?${queryString}`,//任务列表
    EVALUATION_CHECK_LIST: `${HOST}/evaluation/task-user/check-list?${queryString}`,//审核人列表
    EVALUATION_USER_LIST: `${HOST}/evaluation/task-user/sign-list?${queryString}`,//标记人列表
    EVALUATION_TASK_LIST_TREE: `${HOST}/evaluation/task-question/tree?${queryString}`,//任务列表 章节树
    EVALUATION_TASK_QUESTION_LIST: `${HOST}/evaluation/task-question/question-page-evaluation?${queryString}`,//题列表

    EVALUATING_TASK_EXPORT: `${HOST}/evaluation/task/statistics?${queryString}`,//导出



    //6.6
    ALBUM_ONLINE: `${HOST}/framework/album/online?${queryString}`,//上线专辑
    ALBUM_TEST: `${HOST}/framework/album/test?${queryString}`,//上测试专辑
    ALBUM_OFFLINE: `${HOST}/framework/album/offline?${queryString}`,//上线专辑
    ALBUM_PAFGE_ALL_LIST: `${HOST}/framework/album/list?${queryString}`,//专辑全列表
    ALBUM_PAFGE_LIST: `${HOST}/framework/album/page-list?${queryString}`,//专辑列表
    ALBUM_ADD: `${HOST}/framework/album/add?${queryString}`,//专辑增加
    ALBUM_EDIT: `${HOST}/framework/album/edit?${queryString}`,//专辑编辑
    ALBUM_DETAIL: `${HOST}/framework/album/detail?${queryString}`,//专辑详情
    SELECT_ALBUM_LIST: `${HOST}/book_questionall/tree/select-album-list?${queryString}`,//专辑

    //6.9
    ADD_QUESTION_SCORE: `${HOST}/book_questionall/tree/question-sort?${queryString}`,

    //6.9.2
    FRAMEEWORK_CHANGE_MAIN_TYPE: `${HOST}/framework/section-know/change-main?${queryString}`,
    CHANGE_HIDE_HISTORY: `${HOST}/qselectnew/task/change-hide-status?${queryString}`,

    //6.11 ai数独
    CHECK_AISUDOKU: `${HOST}/common/question/check-unique?${queryString}`,
    //7.10.5 ai战舰数独
    CHECK_AISUDOKU_SHIP: `${HOST}/common/question/warship-get-answer?${queryString}`,

    //6.13
    SECTION_TEST: `${HOST}/framework/section/test?${queryString}`,
    //6.14
    SAVE_ARTICLE: `${HOST}/entry_question/article/add?${queryString}`,

    //6.14
    ARTICLE_STATISTIC: `${HOST}/entry_question/article/article-statistic?${queryString}`,//导出文章
    ARTICLE_PAGE_LIST: `${HOST}/entry_question/article/page-list?${queryString}`,//导出文章
    ARTICLE_DOWNLOAD_FORMAT: `${HOST}/entry_question/article/download-import-format?${queryString}`,//下载文章模版

    ARTICLE_BATCH_ADD: `${HOST}/entry_question/article/batch-add?${queryString}`,//导入文章

    ARTICLE_GET_L:`${HOST}/entry_question/article/get-l?${queryString}`,//计算L值
    DEL_ARTICLE:`${HOST}/entry_question/article/del-article?${queryString}`,//计算L值

    ENTRY_TASH_KNOWLEDGE:`${HOST}/entry_task/global/knowledge?${queryString}`,//获取口算树
    ENTRY_TASH_FANHUA:`${HOST}/entry_task/manage/fanhua?${queryString}`,//手动泛化
    ENTRY_TASH_IMPORT_FORMAT:`${HOST}/entry_question/qbox/download-import-format?${queryString}`,//下载导入文章模版
    ENTRY_TASH_BATCH_ADD:`${HOST}/entry_question/qbox/batch-add?${queryString}`,//导入文章
    
    //6.16.0
    SEARCH_ASSIST_BY_ID:`${HOST}/framework/section/search-by-id?${queryString}`,//章节id搜索教辅
    SEARCH_ASSIST_BY_NAME:`${HOST}/framework/section/search-by-name?${queryString}`,//章节名称搜索教辅

    // 7.0-详情
    CURRENT_QUESTION_PAGE: `${HOST}/icon/task-question/question-page?${queryString}`, // 任务进行到的位置
    INSERT_PICTURE: `${HOST}/icon/task-question/icon?${queryString}`, //插画
    MODIFY_PICTURE: `${HOST}/icon/task-question/icon-modify?${queryString}`, // 修改插画
    PICTURE_PASS: `${HOST}/icon/task-question/icon-pass?${queryString}`, // 插花审核通过
    PUCTURE_REWORK: `${HOST}/icon/task-question/icon-rework?${queryString}`, // 插画返工
    SIGN_MODIFY: `${HOST}/icon/task-question/sign-modify?${queryString}`, // 标记修改
    SIGN_REWORK: `${HOST}/icon/task-question/sign-rework?${queryString}`, // 标记返工
    SIGN_PASS: `${HOST}/icon/task-question/sign-pass?${queryString}`, // 标记通过
    SIGN_TITLE: `${HOST}/icon/task-question/sign?${queryString}`, // 标记题目
    TITLE_DETAIL: `${HOST}/icon/task-question/detail?${queryString}`, // 题目详情
    
    //7.0
    IMAGE_CORRECTION_TASK_LIST:`${HOST}/icon/task/page-list?${queryString}`,//图片订正任务列表
    IMAGE_CORRECTION_MEMBER_LIST:`${HOST}/icon/icon-task-user/user-list?${queryString}`,//筛选人员列表
    CREATE_IMAGE_CORRECTION_TASK:`${HOST}/icon/task/add?${queryString}`,//创建图片订正任务
    
    ASSIGN_SIGN_USER:`${HOST}/icon/task/assign-sign-user?${queryString}`,//分配标记员
    ASSIGN_SIGN_CHECK_USER:`${HOST}/icon/task/assign-sign-check-user?${queryString}`,//分配标记审核员
    ASSIGN_ICON_AND_CHECK_USER:`${HOST}/icon/task/assign-icon-user?${queryString}`,//分配插画师和插画审核员
    ASSIGN_ICON_USER:`${HOST}/icon/task/assign-icon-icon-user?${queryString}`,//分配插画师
    ASSIGN_ICON_CHECK_USER:`${HOST}/icon/task/assign-icon-check-user?${queryString}`,//分配插画审核员
    ASSIGN_CHECK_USER:`${HOST}/icon/task/assign-check-user?${queryString}`,//分配题目审核员
    
    SIGNING_SUBMIT:`${HOST}/icon/task/sign-submit?${queryString}`,//标记中-提交
    SIGNING_DELETE:`${HOST}/icon/task/del?${queryString}`,//标记中-删除任务
    SIGN_CHECKING_SUBMIT:`${HOST}/icon/task/sign-check-pass?${queryString}`,//标记审核中-提交
    SIGN_CHECKING_REWORK:`${HOST}/icon/task/sign-rework?${queryString}`,//标记审核中-返工
    SIGN_REWORK_SUBMIT:`${HOST}/icon/task/sign-rework-modify?${queryString}`,//标记返工-提交
    ICONING_SUBMIT:`${HOST}/icon/task/icon-submit?${queryString}`,//插画中-提交
    CHECKING_SUBMIT:`${HOST}/icon/task/icon-check-pass?${queryString}`,//插画审核中-提交；题目审核中-提交
	CHECKING_REWORK:`${HOST}/icon/task/icon-rework?${queryString}`,//插画审核中-返工；题目审核中-返工
    ICON_REWORK_SUBMIT:`${HOST}/icon/task/icon-rework-modify?${queryString}`,//插画返工-提交
    EXPORT_TASK_STATS:`${HOST}/icon/task/statistics?${queryString}`,//订正成功-导出任务统计
	
	//7.1
	EDIT_QUESTION_PACKAGE:`${HOST}/framework/question-pack/mix-add-edit`,//创建、编辑题包
	QUESTION_PACKAGE_LIST:`${HOST}/framework/question-pack/page-list`,//题包列表
	QUESTION_PACKAGE_DETAIL:`${HOST}/framework/question-pack/pack-detail`,//题包详情
	QUESTION_PACKAGE_QUESTION:`${HOST}/framework/question-pack/pack-question-list`,//题包题目
	QUESTION_PACKAGE_CHAPTER:`${HOST}/framework/question-pack/pack-section-detail`,//题包章节
	QUESTION_PACKAGE_BIND_RELATION:`${HOST}/framework/question-pack/add-relate`,//题包关联题目、章节
	ENTRY_USER_LIST:`${HOST}/framework/question-pack/user-list`,//录入人列表	
	GENERALIZE_QUESTION_PACKAGE:`${HOST}/framework/question-pack/fanhua`,//泛化题包
	SUBMIT_QUESTION_PACKAGE:`${HOST}/framework/question-pack/finish-entry`,//提交题包	
	UPTEST_QUESTION_PACKAGE:`${HOST}/framework/question-pack/test`,//上测试题包	
	UPLINE_QUESTION_PACKAGE:`${HOST}/framework/question-pack/online-to-susuan`,//上线题包
	OFFLINE_QUESTION_PACKAGE:`${HOST}/framework/question-pack/offline`,//下线题包
	DELETE_QUESTION_PACKAGE_BIND:`${HOST}/framework/question-pack/del-relate`,//删除关联关系
	CLOSE_TAG_TASK_MSG:`${HOST}/qselectnew/task/check-end`,//关闭打标签任务提示

    // 7.1-题包查看
    LOOK_UP_PACKAGE: `${HOST}/framework/question-pack/relate-pack`, // 查看题包
    DELETE_RELATE: `${HOST}/framework/question-pack/del-relate`, // 删除关联
    
    //7.2 查超纲
    GET_CHINESE_PINYIN:`${HOST}/book_questionall/tree/text-trans-pinyin`, // 汉语拼音
    GET_CHECK_BEYOND_LEVEL_LIST:`${HOST}/qcheck/task/page-list`, // 查超纲任务列表
    GET_CHECK_BEYOND_LEVEL_USER_LIST:`${HOST}/qcheck/task-user/user-list`, // 审查人列表
    CREATE_CHECK_BEYOND_LEVEL_TASK:`${HOST}/qcheck/task/add`, // 创建查超纲任务
    ASSIGN_BEYONGD_CHECK_USER:`${HOST}/qcheck/task-user/assign-check-user`, // 分配审查人
    BEYONGD_CHECKING_SUBMIT:`${HOST}/qcheck/task/submit`, // 进行中提交
    BEYONGD_CHECKING_DELETE:`${HOST}/qcheck/task/del`, // 进行中删除
    BEYONGD_CHECK_FINISH_SUBMIT:`${HOST}/qcheck/task/online-to-base`, // 审查完成提交
    EXPORT_BEYOND_TASK_STATS:`${HOST}/qcheck/task/statistics`,//导出任务统计

    //7.2 查超纲-详情
    SET_STAGE:`${HOST}/qcheck/task-question/set-stage`, // 更改题目状态
    GET_SUPERCLASS_QUESTION_LIST: `${HOST}/qcheck/task-question/question-list`, // 获取题目列表
    GET_SUPERCLASS_QUESTION_filter: `${HOST}/qcheck/task-question/question-filter`, // 获取知识点列表
    GET_SUPERCLASS_TREE_LIST: `${HOST}/qcheck/task-question/tree-list`, // 获取章节列表

    // 7.3-人工精题包（详情）
    MODIFY_SORT_VALUE: `${HOST}/qselectbag/task-question/change-score`, // 修改排序值
    QEUESTION_PACKAGE_REWORK: `${HOST}/qselectbag/task-question/check-rework`, // 返工题目
    OPTION_QUESTION: `${HOST}/qselectbag/task-question/select-question`, // 操作题目（选中/移除题目）
    OPTION_PASS_QUESTION: `${HOST}/qselectbag/task-question/check-pass`, // 通过题目
    GET_PACKAGE_QUESTION_LIST: `${HOST}/qselectbag/task-question/question-list`, // 题目列表
    GET_QUESTION_FILTER_LIST: `${HOST}/qselectbag/task-question/question-filter`, // 题目筛选项目
    
    GOOD_PACKAGE_USER_LIST:`${HOST}/qselectbag/task-user/user-list`, // 人员列表
    GOOD_PACKAGE_LIST:`${HOST}/qselectbag/task/page-list`, // 任务列表
    TYPE_ASSIST_LIST:`${HOST}/book_questionall/tree/type-assist-list`, // 分类获取教辅
    OTHER_INIT_SECTION:`${HOST}/book_questionall/tree/get-relate-base-section`, // 根据精题包初始化其他类型章节
    CREATE_GOOD_PACKAGE_TASK:`${HOST}/qselectbag/task/add`, // 创建任务
    ASSIGN_GOOD_PACKAGE_SELECT_USER:`${HOST}/qselectbag/task-user/assign-select-user`, // 分配选精员
    ASSIGN_GOOD_PACKAGE_CHECK_USER:`${HOST}/qselectbag/task-user/assign-check-user`, // 分配审核员
    GOOD_PACKAGE_SELECTING_SUBMIT:`${HOST}/qselectbag/task/submit`, // 选精中-提交
    GOOD_PACKAGE_SELECTING_DELETE:`${HOST}/qselectbag/task/del`, // 选精中-删除
    GOOD_PACKAGE_CHECKING_SUBMIT:`${HOST}/qselectbag/task/check-pass`, // 审核中-提交
    GOOD_PACKAGE_CHECKING_REWORK:`${HOST}/qselectbag/task/check-rework`, // 审核中-返工
    GOOD_PACKAGE_REWORK_SUBMIT:`${HOST}/qselectbag/task/check-modify`, // 返工-提交
    GOOD_PACKAGE_CHECK_FINISH_STORAGE:`${HOST}/qselectbag/task/online-to-base`, // 审核完成-入库
    GOOD_PACKAGE_STORAGE_UPLINE:`${HOST}/qselectbag/task/online-to-susuan`, // 已入库-上线
    GOOD_PACKAGE_STORAGE_UPTEST:`${HOST}/qselectbag/task/test`, // 已入库-上测试
    GOOD_PACKAGE_EXPORT_TASK_STATS:`${HOST}/qselectbag/task/statistics`, // 导出任务
    
    //7.3.1--语文保存新题
    SAVE_NEW_QUESTION:`${HOST}/common/question/add`, // 保存新题
    
    //7.4题型模板
    GET_QUESTION_TEMP_LIST:`${HOST}/entry_question/temp/type-show-temp-list`, // 题型模板列表
    GET_ALL_QUESTION_TEMP_LIST:`${HOST}/entry_question/temp/page-list`, // 所有题型模板列表
    DELETE_QUESTION_TEMP:`${HOST}/entry_question/temp/del`, // 删除模板
    MODIFY_TEMP_STATUS:`${HOST}/entry_question/temp/change-stage`, // 修改模板状态
    GET_TEMP_USER_LIST:`${HOST}/entry_question/temp/user-list`, // 创建人列表
    ADD_EDIT_TEMPLATE: `${HOST}/entry_question/temp/mix-add-edit`, // 添加/编辑模版
    ADD_GUIDE: `${HOST}/entry_question/temp/add-word`, // 添加引导语
    GET_TEMPLATR_DETAIL: `${HOST}/entry_question/temp/temp-detail`, // 获取模版详情
    
    //7.5 AI直播课新题型
    CHECK_SECTION_USED: `${HOST}/qselectbag/task/judge-select`, // 人工精题包任务创建校验
    
    //7.7语文阅读分类标签
    CREATE_CATEGORY_LABEL:`${HOST}/framework/cateitem/add`, // 添加分类标签
    DELETE_CATEGORY_LABEL:`${HOST}/framework/cateitem/del`, // 删除分类标签
    //7.8.3 打标签支持关联字词
    ADD_NEW_WORD_CHECK:`${HOST}/qselectnew/task-question/check-select-submit`, //新字词检查
    
    //7.8.2
    GET_NO_AUTH_TREE_LIST: `${HOST}/framework/no-auth-tree/tree-list`,
    
    //7.9题目日志
    GET_QUESTION_RECORD:`${HOST}/framework/log-question/question-log-list`, //获取题目日志
    GET_RELATION_RECORD:`${HOST}/framework/log-question/question-section-log-list`, //获取关联关系日志
    
    //7.9.1
    FRAMEEWORK_SECTION_AREA_ADD:`${HOST}/framework/section-city/add`, //教辅添加区域
    FRAMEEWORK_SECTION_AREA_DELETE:`${HOST}/framework/section-city/del`, //教辅删除区域
    FRAMEEWORK_AREA_TREE:`${HOST}/framework/city/list`, //区域列表
    //7.10
    EDIT_CATE_ITEM:`${HOST}/framework/cateitem/edit`, //编辑词库管理
    DELETE_CATE_ITEM:`${HOST}/framework/cateitem/del`, //删除词库管理

    //
    QSHOW_QUESTION_ADD:`${HOST}/common/question/add-new`, // 总库保存题目
    
    
    BATCH_ONLINE_RELATION:`${HOST}/book_questionall/tree/online-section-question`,//批量上线关联关系
    BATCH_OFFLINE_RELATION:`${HOST}/book_questionall/tree/offline-section-question`,//批量上线关联关系

     // 写字课题型 - 字库相关接口
     SEARCH_WORD_BANK: `${HOST}/common/question/search-word-bank`, // 搜索字库
     ADD_WORD_BANK: `${HOST}/common/question/add-word-bank`, // 添加字库
}
export default API;






// WEBPACK FOOTER //
// ./src/API/api.js